import React from "react";
import { Link } from "react-router-dom";
import slugify from "slugify";
import { siteUrl } from "../../utils/constants";
import { CaseEntity } from "../../types/strapi";
import { mediaUrl } from "../../utils/imageUtils";

interface CasesListProps {
  postList?: CaseEntity[];
}

const CasesList: React.FC<CasesListProps> = ({ postList }) => {
  const getCasePath = (name: string) =>
    name ? `/cases/${slugify(name.toLowerCase())}` : "#";

  const getImageUrl = (item: any, index: number) =>
    item?.backgroundImage?.formats?.small?.url
      ? mediaUrl(item.backgroundImage.formats.small.url)
      : `/assets/images/blog/blog-0${index + 1}.jpg`;

  return (
    <div className="row mt_dec--30" style={{ minHeight: "75vh" }}>
      {postList?.map((item, index) => {
        const casePath = getCasePath(item?.name || "");
        const imageUrl = getImageUrl(item, index);
        const itemName = item?.name;

        return (
          <div className="col-lg-4 col-md-6 col-sm-6 col-12 mt--30" key={index}>
            <div className="im_box">
              <div className="thumbnail">
                <span className="content-type-badge">
                  {item?.isBook ? "Book" : "Case"}
                </span>
                <Link to={casePath}>
                  <img className="w-100" src={imageUrl} alt="user Uploads" />
                </Link>
              </div>
              <div className="content">
                <div className="inner">
                  <div className="content_heading">
                    <h4 className="title">
                      <Link to={casePath}>{itemName}</Link>
                    </h4>
                  </div>
                  <div className="content_footer">
                    <Link to={casePath} className="rn-btn btn-opacity">
                      {itemName ? "Read more" : "In Progress"}
                    </Link>
                  </div>
                </div>
                <Link to={casePath} className="transparent_link" />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default CasesList;
